import { Sort } from '@angular/material/sort';
import { GradedUnit } from 'app/library/graded-unit/models/graded-unit.model';
import { PartialGrade } from 'app/library/partial-grade/models/partial-grade.model';

export class SetGradedUnitPartialGrades {
    static readonly type = '[GradedUnitPartialGrades] SetGradedUnitPartialGrades';

    constructor(public payload: PartialGrade[]) {}
}

export class UnsetGradedUnitPartialGrades {
    static readonly type = '[GradedUnitPartialGrades] UnsetGradedUnitPartialGrades';
}

export class FetchGradedUnitPartialGrades {
    static readonly type = '[GradedUnitPartialGrades] FetchGradedUnitPartialGrades';

    constructor(
        public payload: {
            gradedUnit: GradedUnit;
            search: string;
            sortBy: string;
            sortOrder: string;
            pageSize: number;
            pageNumber: number;
        }
    ) {}
}

export class FetchGradedUnitPartialGradesSuccess {
    static readonly type = '[GradedUnitPartialGrades] FetchGradedUnitPartialGradesSuccess';
}

export class FetchGradedUnitPartialGradesFailure {
    static readonly type = '[GradedUnitPartialGrades] FetchGradedUnitPartialGradesFailure';
}

export class ToggleSelectedGradedUnitPartialGrade {
    static readonly type = '[GradedUnitPartialGrades] ToggleSelectedGradedUnitPartialGrade';

    constructor(public payload: string) {}
}

export class SelectFilteredGradedUnitPartialGrades {
    static readonly type = '[GradedUnitPartialGrades] SelectFilteredGradedUnitPartialGrades';
}

export class DeselectSelectedGradedUnitPartialGrades {
    static readonly type = '[GradedUnitPartialGrades] DeselectSelectedGradedUnitPartialGrades';
}

export class SearchGradedUnitPartialGrades {
    static readonly type = '[GradedUnitPartialGrades] SearchGradedUnitPartialGrades';

    constructor(public payload: string) {}
}

export class SortGradedUnitPartialGrades {
    static readonly type = '[GradedUnitPartialGrades] SortGradedUnitPartialGrades';

    constructor(public payload: Sort) {}
}
